import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatMenuModule],
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss']
})
export class UserProfileComponent implements OnInit, OnDestroy {
  private authService = inject(AuthService);
  private readonly _destroying$ = new Subject<void>();

  // Cache these values instead of computing them on every change detection
  isLoggedIn = false;
  userName = '';
  userEmail = '';

  ngOnInit(): void {
    // Subscribe to authentication state changes from AuthService
    this.authService.isAuthenticated$
      .pipe(takeUntil(this._destroying$))
      .subscribe((isAuthenticated) => {
        this.isLoggedIn = isAuthenticated;
        this.updateUserInfo();
      });
  }

  private updateUserInfo(): void {
    if (this.isLoggedIn) {
      const account = this.authService.getActiveAccount();
      this.userName = account?.name || '';
      this.userEmail = account?.username || '';
    } else {
      this.userName = '';
      this.userEmail = '';
    }
  }

  logout(): void {
    this.authService.logout();
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }
}
